export default "__VITE_ASSET__8vtrw9K7__"